import { render, staticRenderFns } from "./TakipDetayView.vue?vue&type=template&id=d716d400&scoped=true"
import script from "./TakipDetayView.vue?vue&type=script&lang=ts"
export * from "./TakipDetayView.vue?vue&type=script&lang=ts"
import style0 from "./TakipDetayView.vue?vue&type=style&index=0&id=d716d400&prod&scoped=true&lang=css"
import style1 from "./TakipDetayView.vue?vue&type=style&index=1&id=d716d400&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d716d400",
  null
  
)

export default component.exports